// Unpublished Work © 2021-2023 Deere & Company

import t from 'tcomb';
import {addressType, AddressType} from '../../enum/address-type';
import {AddressComponent} from '../add-customer/customer-address';

export const Address = t.struct({
    addressComponent: t.maybe(AddressComponent),
    addressLine1: t.String,
    addressLine2: t.String,
    admin1: t.String,
    admin2: t.String,
    admin3: t.String,
    admin4: t.String,
    admin5: t.String,
    caCcsdCode: t.String,
    caCdCode: t.String,
    canMarket: t.Boolean,
    canShowAsterisk: t.maybe(t.Boolean),
    commTypeId: t.String,
    communicationLocatorId: t.Number,
    city: t.String,
    countryCode: t.String,
    countyName: t.maybe(t.String),
    formattedCityStatePostal: t.String,
    isSelected: t.Boolean,
    isUndeliverable: t.Boolean,
    latitude: t.String,
    longitude: t.String,
    postalCode: t.String,
    type: t.maybe(AddressType),
    stateCode: t.String,
    usCountyCode: t.String,
    certificationCode: t.String,
    certificationDate: t.String,
    certificationDescription: t.String,
    geoAccuracyId: t.String,
    postalCertified: t.String
}, {
    defaultProps: {
        addressComponent: new AddressComponent({}),
        addressLine1: '',
        addressLine2: '',
        admin1: '',
        admin2: '',
        admin3: '',
        admin4: '',
        admin5: '',
        caCcsdCode: '',
        caCdCode: '',
        canMarket: true,
        canShowAsterisk: false,
        commTypeId: '',
        communicationLocatorId: 0,
        city: '',
        countryCode: '',
        countyName: '',
        formattedCityStatePostal: '',
        isSelected: false,
        isUndeliverable: false,
        latitude: '',
        longitude: '',
        postalCode: '',
        stateCode: '',
        usCountyCode: '',
        certificationCode: '',
        certificationDate: '',
        certificationDescription: '',
        geoAccuracyId: '',
        postalCertified: ''
    },
    name: 'Address'
});

Address.prototype.getLabel = function () {
    return {
        [addressType.MAILING]: 'labels.MAILING_ADDRESS',
        [addressType.PHYSICAL]: 'labels.PHYSICAL_ADDRESS'
    }[this.type];
};

Address.prototype.canAddressSectionBeReset = function () {
    const defaultAddress = new Address({});

    return [
        this.addressLine1 !== defaultAddress.addressLine1,
        this.addressLine2 !== defaultAddress.addressLine2,
        this.city !== defaultAddress.city,
        this.stateCode !== defaultAddress.stateCode,
        this.postalCode !== defaultAddress.postalCode
    ].some((condition) => condition);
};

Address.prototype.canCompareAddressSectionBeReset = function () {
    const defaultAddress = new Address({});

    return [
        this.addressLine1 !== defaultAddress.addressLine1,
        this.addressLine2 !== defaultAddress.addressLine2,
        this.city !== defaultAddress.city,
        this.stateCode !== defaultAddress.stateCode,
        this.postalCode !== defaultAddress.postalCode
    ].some((condition) => condition);
};

Address.prototype.isAddressEmpty = function () {
    return [
        !this.addressLine1,
        !this.addressLine2,
        !this.city,
        !this.countryCode,
        !this.stateCode,
        !this.postalCode
    ].every((condition) => condition);
};
